import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken, formatApiError } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(
        formatApiError(err.response?.data?.detail) || "Bejelentkezési hiba.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 relative overflow-hidden"
      data-testid="admin-login-page"
    >
      <div className="absolute top-0 left-0 right-0 m-stripe h-[3px]" />

      <div className="w-full max-w-md">
        <Link
          to="/"
          className="flex items-center gap-4 justify-center mb-10 group"
          data-testid="login-logo-link"
        >
          <div className="m-stripe w-1.5 h-12" />
          <span
            className="text-4xl font-black uppercase tracking-tight text-white"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            Autó-<span className="text-[#0082D2]">Szerelem</span>
          </span>
        </Link>

        <div className="bg-[#101010] border border-white/5 p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock className="w-5 h-5 text-[#0082D2]" strokeWidth={1.6} />
            <span
              className="text-[0.7rem] font-bold uppercase tracking-[0.24em] text-zinc-400"
              style={{ fontFamily: "Barlow Condensed" }}
            >
              Belépés / Admin
            </span>
          </div>
          <h1
            className="text-3xl font-black uppercase text-white tracking-tight"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            Adminisztrációs panel
          </h1>
          <p className="text-sm text-zinc-400 mt-3">
            Foglalások és üzenetek kezelése.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <label className="block">
              <span className="label-text">E-mail cím</span>
              <input
                required
                type="email"
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                autoComplete="email"
              />
            </label>
            <label className="block">
              <span className="label-text">Jelszó</span>
              <input
                required
                type="password"
                className="input-field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                autoComplete="current-password"
              />
            </label>

            {error && (
              <div
                className="text-sm text-red-400 border border-red-500/30 bg-red-500/5 px-4 py-3"
                data-testid="login-error"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-50"
              data-testid="login-submit-btn"
            >
              {loading ? "Belépés..." : "Belépés"}
            </button>
          </form>
        </div>

        <Link
          to="/"
          className="block text-center mt-6 text-xs text-zinc-500 hover:text-zinc-300 uppercase tracking-[0.2em]"
          data-testid="login-back-link"
        >
          ← Vissza a főoldalra
        </Link>
      </div>
    </div>
  );
}
